import React from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="py-24 text-center px-4">
          <h2 className="text-2xl font-bold text-slate-900 mb-3">Ocurrió un error inesperado</h2>
          <p className="text-slate-500 mb-6">No se pudo cargar esta sección.</p>
          <Link to="/" className="px-5 py-2.5 rounded-full bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-semibold hover:scale-105 transition-all">
            Volver al inicio
          </Link>
        </div>
      );
    }
    return this.props.children;
  }
}
